import EdoBusiness from './EdoBusiness';

export default EdoBusiness;
